import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class RetencaoVeiculoService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/retencao_veiculo`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    categoria_os?: any, 
    filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/retencao_veiculo/'}`, {
      headers: this.getAuthHeaders(),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('categoria_os', categoria_os.toString())
    });
  }

  public getPrimeiroRetornoMensal(data_inicial: any, data_final: any, ano: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService}/retencao_veiculo/primeiro_retorno_mensal`, {
      headers: this.getAuthHeaders(),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('ano', ano.toString())
    });
  }

  public getPrimeiroRetornoFamilia(
    data_inicial: any,
    data_final: any,
    ano: number,
    ano_visita: number,
    mes_visita: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService}/retencao_veiculo/primeiro_retorno_mensal/familia`, {
      headers: this.getAuthHeaders(),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('ano', ano.toString())
        .set('ano_visita', ano_visita.toString())
        .set('mes_visita', mes_visita.toString())
    });
  }

  public getPrimeiroRetornoFamiliaDetalhe(
    data_inicial: any,
    data_final: any,
    ano: number,
    ano_visita: number,
    mes_visita: number,
    id_padrao_veiculos?: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService}/retencao_veiculo/primeiro_retorno_mensal/familia/detalhe`, {
      headers: this.getAuthHeaders(),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('ano', ano.toString())
        .set('ano_visita', ano_visita.toString())
        .set('mes_visita', mes_visita.toString())
        .set('id_padrao_veiculos', id_padrao_veiculos == null ? 'null' : id_padrao_veiculos.toString())
    });
  }

  private getAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
    });
  }
}
